import { ThemeProvider } from '@ori-ui/mui';
import { TestIdProvider } from '@ori/testid-generator';
import { BrowserRouter as Router } from 'react-router-dom';
import { I18nContainer, ErrorBoundary, DevelopmentEnvironmentProvider, ApiProvider, PersonalMenuSection } from './containers';
import { ConfigurationProvider } from './contexts';
import { jsx as _jsx } from "react/jsx-runtime";
export * from './models/AppConfiguration';
var project = 'personal-menu';
export var PersonalMenu = function PersonalMenu(_ref) {
  var configuration = _ref.configuration;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(ConfigurationProvider, {
      value: configuration,
      children: /*#__PURE__*/_jsx(ApiProvider, {
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          enableCacheProvider: true,
          cacheKey: project,
          children: /*#__PURE__*/_jsx(TestIdProvider, {
            team: "Growth",
            project: project,
            children: /*#__PURE__*/_jsx(DevelopmentEnvironmentProvider, {
              children: /*#__PURE__*/_jsx(I18nContainer, {
                children: /*#__PURE__*/_jsx(Router, {
                  children: /*#__PURE__*/_jsx(PersonalMenuSection, {})
                })
              })
            })
          })
        })
      })
    })
  });
};